// extracted by mini-css-extract-plugin
export default {"title":"style_title__Iqoxi","attention":"style_attention__SZn7K","buttons":"style_buttons__0r2gb"};